import script from "./PageTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageTitle.vue?vue&type=script&lang=ts&setup=true"

import "./PageTitle.vue?vue&type=style&index=0&id=e087f846&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e087f846"]])

export default __exports__